<template>
  <div>
    <!-- This component handles SEO meta tags via composable -->
  </div>
</template>

<script setup lang="ts">
import { useSEO } from '~/composables/useSEO.js'

interface Props {
  title?: string
  description?: string
  keywords?: string[]
  image?: string
  url?: string
  type?: 'website' | 'article'
  publishedTime?: string
  modifiedTime?: string
  author?: string
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  description: '',
  keywords: () => [],
  image: '/images/logo-light.svg',
  url: '',
  type: 'website',
  publishedTime: '',
  modifiedTime: '',
  author: 'Vedware',
})

const { setPageSEO } = useSEO()

// Set SEO meta tags when component mounts
setPageSEO({
  title: props.title,
  description: props.description,
  keywords: props.keywords,
  image: props.image,
  url: props.url,
  type: props.type,
  publishedTime: props.publishedTime,
  modifiedTime: props.modifiedTime,
  author: props.author,
})
</script>
